/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file functions to export from i18n
 * @author Razi Rais
 * @module Epic.VideoApp.Utils.I18n.Index
 */

export * from "./i18n";
export * from "./i18nUtils";
